import React from 'react';
import { withFormik, FormikProps } from 'formik';
import { IntlShape, injectIntl } from 'react-intl';
import { Grid, Box } from '@material-ui/core';

import InputField from 'components/InputField';
import validationSchema from 'containers/LoginRecoveryPage/InsertInfosPage/validationSchema';
import messages from 'containers/LoginRecoveryPage/InsertInfosPage/messages';
import { translate } from 'helpers/intl';
import { StyledOrangeButton } from 'containers/LoginRecoveryPage/InsertInfosPage/styles';
import ErrorMessage from 'components/ErrorMessage';
import GATracking, { EVENT_ACTION, EVENT_CATEGORIES } from 'helpers/GATracking';
import GaClickHOC from 'helpers/GATracking/GaClickHOC';

const InsertInfosForm = (
  props: { loader?: boolean; errorMessage?: string } & FormikProps<FormValues>,
) => {
  const {
    values,
    errors,
    handleSubmit,
    handleChange,
    handleBlur,
    touched,
  } = props;

  const handleErrorMessage = () => {
    GATracking.event(
      EVENT_CATEGORIES.RECOVERY_LOGIN,
      EVENT_ACTION.ERROR,
      "Chargement du bloc d'erreur",
    );
    return (
      <Box mb={2} paddingX={[2, 4, 8]}>
        <Grid item>
          <ErrorMessage
            message={translate({ ...messages.InfosError }, props)}
          />
        </Grid>
      </Box>
    );
  };

  return (
    <form onSubmit={handleSubmit}>
      {props.errorMessage && handleErrorMessage()}
      <Box paddingY={2} paddingX={[2, 4, 8]}>
        <Grid item>
          <InputField
            name="birthday"
            label={translate({ ...messages.birthday }, props)}
            placeholder={translate({ ...messages.birthday }, props)}
            value={values.birthday}
            type="date"
            error={touched.birthday && errors.birthday}
            helperText={touched.birthday && errors.birthday}
            handleChange={handleChange}
            handleBlur={handleBlur}
            InputLabelProps={{
              shrink: true,
            }}
            InputProps={{
              inputProps: { max: '9999-12-30' },
            }}
          />
        </Grid>
        <Box marginBottom={2}></Box>
        <Grid item>
          <InputField
            name="cin"
            label={translate({ ...messages.cin }, props)}
            placeholder={translate({ ...messages.cin }, props)}
            value={values.cin}
            error={touched.cin && errors.cin}
            helperText={touched.cin && errors.cin}
            handleChange={handleChange}
            handleBlur={handleBlur}
          />
        </Grid>
        <Box marginBottom={2}></Box>
        <Grid>
          <GaClickHOC
            category={EVENT_CATEGORIES.RECOVERY_LOGIN}
            label="Suivant"
          >
            <StyledOrangeButton type="submit" variant="contained">
              <React.Fragment>
                {translate({ ...messages.valid }, props)}
              </React.Fragment>
            </StyledOrangeButton>
          </GaClickHOC>
        </Grid>
      </Box>
    </form>
  );
};

export interface FormProps {
  intl: IntlShape;
  loader?: boolean;
  onSubmit: Function;
  errorMessage?: string;
}

interface FormValues {
  birthday: string;
  cin: string;
}

const Form = withFormik<FormProps, FormValues>({
  mapPropsToValues: () => {
    return {
      birthday: '',
      cin: '',
    };
  },

  validationSchema,

  handleSubmit: (values, { props }) => {
    props.onSubmit({ bday: values.birthday, cin: values.cin });
  },
})(InsertInfosForm);

export default injectIntl(Form);
